const sharedClasses =
    "h-[50px] px-[60px] w-auto  relative inline-flex items-center justify-center whitespace-nowrap rounded-[100px] text-base font-bold leading-snug border  transition-colors active:ring-4 disabled:opacity-25 disabled:cursor-not-allowed";

export const rawButtonVariants = {
    primary: `${sharedClasses} bg-brand-primary !text-brand-white border-brand-primary hover:bg-brand-primary-darken active:bg-brand-primary-darken active:ring-brand-primary-darken/40`,
    secondary: `${sharedClasses} bg-brand-success !text-brand-white border-brand-success hover:bg-brand-success-darken active:bg-brand-success-darken active:ring-brand-success-darken/40`,
    tertiary: `${sharedClasses} bg-brand-secondary !text-brand-white border-brand-black hover:!text-brand-white hover:bg-brand-secondary-darken active:!text-brand-white active:bg-brand-secondary-darken active:ring-brand-secondary-darken/40`,
    quaternary: `${sharedClasses} bg-brand-quaternary !text-brand-white border-brand-quaternary hover:bg-brand-quaternary-darken active:bg-brand-quaternary-darken active:ring-brand-quaternary-darken/40`,
    quinary: `${sharedClasses} bg-brand-quinary !text-brand-white border-brand-quinary hover:bg-brand-quinary-darken active:bg-brand-quinary-darken active:ring-brand-quinary-darken/40`,
    sextary: `${sharedClasses} bg-brand-tertiary !text-brand-white border-brand-tertiary hover:bg-brand-tertiary-darken active:bg-brand-tertiary-darken active:ring-brand-tertiary-darken/40`,
    transparent: `${sharedClasses} bg-brand-transparent !text-brand-black !border-brand-black hover:bg-brand-black hover:!text-brand-white active:bg-brand-black active:ring-brand-black`,
    link: `${sharedClasses} bg-transparent text-brand-secondary border-transparent hover:text-brand-secondary-darken hover:underline active:ring-0 font-normal`,
    backToTop: `${sharedClasses} bg-brand-grey text-brand-dark-grey border-brand-grey hover:bg-brand-grey-darken active:bg-brand-grey-darken active:ring-brand-grey-darken/40 py-[10px] px-[15px] normal-case text-sm`,
};

export const buttonVariants = {
    primary: {
        solidClasses: rawButtonVariants.primary,
        outlinedClasses: rawButtonVariants.primary,
    },
    secondary: {
        solidClasses: rawButtonVariants.secondary,
        outlinedClasses: rawButtonVariants.secondary,
    },
    tertiary: {
        solidClasses: rawButtonVariants.tertiary,
        outlinedClasses: rawButtonVariants.tertiary,
    },
    quaternary: {
        solidClasses: rawButtonVariants.quaternary,
        outlinedClasses: rawButtonVariants.quaternary,
    },
    quinary: {
        solidClasses: rawButtonVariants.quinary,
        outlinedClasses: rawButtonVariants.quinary,
    },
    sextary: {
        solidClasses: rawButtonVariants.sextary,
        outlinedClasses: rawButtonVariants.sextary,
    },
    link: {
        solidClasses: rawButtonVariants.link,
        outlinedClasses: rawButtonVariants.link,
    },
    transparent: {
        solidClasses: rawButtonVariants.transparent,
        outlinedClasses: rawButtonVariants.transparent,
    },
};
